import { render } from "./PageAdminIngredients.vue?vue&type=template&id=8225384e"
import script from "./PageAdminIngredients.vue?vue&type=script&lang=js"
export * from "./PageAdminIngredients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__